import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import TagCard from "../../../../components/Cards";
import Spinner from "../../../../components/UI/Spinner";
import RoundedButton from "../../../../components/Buttons/RoundedButton";
import InviteActions from "../InviteActions/InviteActions";
import H1 from "../../../../components/UI/Titles/H1/h1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from "@mui/material/Grid2";

const InviteContainer = ({
  title,
  description,
  value,
  isCopied,
  isFetching,
  onCopy,
  onGenerate,
  classes,
  icon,
  generateButtonText,
  actions = true,
  upgradeAlert,
  hasError,
  type,
}) => {
  return (
    <Grid item xs={12} sm={8} md={6} lg={4}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 1087,
        }}
      >
        {/* Cartão estilizado para conter todo o conteúdo */}
        <TagCard className={"center " + classes.InviteCode}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width:"100%",
              margin: "0 15px",
              padding: "0 20px 20px 0px",
              "@media (max-width:425px)": {
                alignItems: "center",
                margin: "0",
              },
            }}
          >
            {/* Cabeçalho com ícone e título */}
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#e2d7ea",
                  color: "#662D91",
                  borderRadius: "4px",
                  fontSize: "1.6rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "10px",
                }}
              >
                {/* Ícone de link */}
                <FontAwesomeIcon icon={icon} />
              </Box>
              <H1 huge className={classes.MainTitle}>
                {title}
              </H1>
            </Box>

            {/* Conteúdo abaixo do título */}
            <Box sx={{ width:"90%", marginLeft: "15px" }}>
              {/* Texto explicativo */}
              <Typography
                sx={{
                  marginBottom: "15px",
                  color: "#666666",
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                {description}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: "18px",
                  width: "100%",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  "@media (max-width:740px)": {
                    flexDirection: "column",
                  },
                }}
              >
                {/* Campo de texto com o link gerado */}
                <Box
                  sx={{
                    flex: 1,
                    width: {
                      xs: "100%",
                      sm: "400px",
                      md: "500px",
                      lg: "580px",
                    },
                  }}
                >
                  <TextField
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={value}
                    disabled // Apenas leitura
                    sx={{
                      "& .Mui-disabled": {
                        WebkitTextFillColor: "#000",
                        opacity: 1,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderStyle: "dashed",
                        borderColor: "#ccc",
                      },
                      backgroundColor: "#F9FAFC",
                    }}
                  />
                </Box>

                {/* Botão para gerar ou gerar novo link */}
                <Box
                  sx={{
                    display: "flex",
                    gap: "20px",
                    marginTop: { xs: "20px", sm: 0 }, // aplica margem no mobile, remove em telas maiores
                    textTransform: "lowercase",
                  }}
                >
                  <RoundedButton
                    style={{
                      width: "200px",
                      height: "45px",
                      cursor: hasError ? "not-allowed" : "pointer",
                    }}
                    text={value === "" ? generateButtonText : "GERAR NOVO"}
                    className={classes.BtnInviteCode}
                    onClick={onGenerate}
                    disabled={hasError}
                  />
                </Box>
              </Box>

              {/* Spinner exibido enquanto carrega */}
              {isFetching && (
                <Box mt={2}>
                  <Spinner className={classes.Spinner} />
                </Box>
              )}

              {/* Ações adicionais exibidas se o link foi gerado */}
              {value !== "" && actions && (
                <Box
                  sx={{
                    mt: 3,
                    width: "100%",
                    mx: "auto",
                    px: { xs: 1, sm: 0 },
                  }}
                >
                  <InviteActions
                    type={type}
                    value={value}
                    isCopied={isCopied}
                    onCopy={onCopy}
                    className={classes.BtnInviteCode}
                  />
                </Box>
              )}
            </Box>
          </Box>
          {upgradeAlert}
        </TagCard>
      </Box>
    </Grid>
  );
};

export default InviteContainer;
